/* Paquito Jamon — Theme JS */

// Update cart count badge everywhere after any cart change
function pqUpdateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const count = cart.item_count;
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
      document.querySelectorAll('.cart-count-text').forEach(el => {
        el.textContent = count;
      });
    });
}
// Keep count fresh on page load and after back-navigation
document.addEventListener('DOMContentLoaded', pqUpdateCartCount);
window.addEventListener('pageshow', function(e) {
  if (e.persisted) pqUpdateCartCount();
});

// Prevent header search from submitting empty query — focus input instead
function pqSearchSubmit(form) {
  const input = form.querySelector('input[name="q"]');
  if (!input || !input.value.trim()) {
    input && input.focus();
    return false;
  }
  return true;
}

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile nav ──
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const siteNav = document.getElementById('siteNav');
  if (menuBtn && siteNav) {
    menuBtn.addEventListener('click', () => {
      siteNav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', siteNav.classList.contains('open'));
    });
  }

  // ── Sticky header shadow ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 20px rgba(0,0,0,0.08)'
        : 'none';
    });
  }

  // ── Variant selection on product page ──
  const variantBtns = document.querySelectorAll('.variant-btn');
  if (variantBtns.length) {
    variantBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const optionPos = this.dataset.option;
        // Deactivate siblings in same option group
        document.querySelectorAll(`.variant-btn[data-option="${optionPos}"]`)
          .forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        updateVariantId();
      });
    });
  }

  function updateVariantId() {
    const selectedValues = {};
    document.querySelectorAll('.variant-btn.active').forEach(btn => {
      selectedValues[btn.dataset.option] = btn.dataset.value;
    });
    // Match against product variants via Shopify's JSON
    const variantJson = document.getElementById('product-variants-json');
    if (!variantJson) return;
    const variants = JSON.parse(variantJson.textContent);
    const match = variants.find(v => {
      return Object.entries(selectedValues).every(([pos, val]) => {
        return v['option' + pos] === val;
      });
    });
    if (match) {
      const input = document.querySelector('[name="id"]');
      if (input) input.value = match.id;
      // Update price
      const priceEl = document.querySelector('.product-info-price-row .price');
      if (priceEl && match.price) {
        const formatted = (match.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        priceEl.textContent = formatted;
      }
    }
  }

  // ── Smooth add to cart feedback + live cart count ──
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const addBtn = this.querySelector('[name="add"]');
      const formData = new FormData(this);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => pqUpdateCartCount())
        .catch(() => {});
      if (addBtn) {
        const original = addBtn.textContent;
        addBtn.textContent = 'Added!';
        addBtn.style.background = '#1D9E75';
        addBtn.style.borderColor = '#1D9E75';
        setTimeout(() => {
          addBtn.textContent = original;
          addBtn.style.background = '';
          addBtn.style.borderColor = '';
        }, 2000);
      }
    });
  }

  // ── Announcement bar dismiss ──
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar && sessionStorage.getItem('announcementDismissed')) {
    announcementBar.style.display = 'none';
  }

  // ── Scroll-reveal for product cards ──
  if ('IntersectionObserver' in window) {
    const cards = document.querySelectorAll('.product-card, .category-card, .testimonial-card');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    cards.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      observer.observe(card);
    });
  }

});
